import React from 'react';
import './WidgetPageShell.less';

export interface WidgetPageShellProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Widget-only layout shell.
 * - Fills the iframe/site width; the host controls the available width.
 * - On mobile (< 600) the content keeps the Figma 16px side padding.
 * - Authentication is handled once above all routes by AuthGate.
 */
const WidgetPageShell: React.FC<WidgetPageShellProps> = ({ children, className }) => {
  return (
    <div className="widget-shell">
      <div className="widget-shell__content">
        {className ? <div className={className}>{children}</div> : children}
      </div>
    </div>
  );
};

export default WidgetPageShell;
